import React, { useMemo } from "react";
import { makeStyles } from "tss-react/mui";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import Collapse from "@mui/material/Collapse";

import { Virtuoso } from "react-virtuoso";

const useStyles = makeStyles()((theme) => ({
  ListItemButton: {
    wordBreak: "break-all",
    padding: "4px 8px",
  },
  ListItemText: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
  },
  CollapseList: {
    "& .MuiListItemButton-root": {
      padding: "2px 5px",
    },
    "& .MuiTypography-root": {
      fontSize: "14px",
    },
  },
  fieldType: {
    minWidth: "100px",
  },
}));

function CollapsibleVirtulizedList({
  currentMapping,
  openedList,
  name,
  fields,
  checkDisabled,
  saveDisabled,
  selectedMapping,
  handleSelect,
}) {
  const { classes } = useStyles();

  const { filedHeight, maxHeight, initialItemCount } = useMemo(() => {
    return {
      filedHeight: 33,
      maxHeight: 550,
      initialItemCount: 70,
    };
  }, []);

  return (
    <Collapse in={openedList === name} timeout="auto" unmountOnExit>
      <List component="div" disablePadding className={classes.CollapseList}>
        {fields.length > 0 ? (
          <Virtuoso
            style={{
              height: `${
                fields.length > 0
                  ? (fields.length * filedHeight > maxHeight ? maxHeight : fields.length * filedHeight) + 50
                  : 0
              }px`,
            }}
            totalCount={fields.length}
            data={fields}
            itemContent={(index, field) => {
              return (
                <ListItemButton
                  selected={selectedMapping.entity === name && selectedMapping.field === field.name}
                  disabled={
                    !(selectedMapping.entity === name && selectedMapping.field === field.name) &&
                    checkDisabled(name, field.name)
                  }
                  key={field.name}
                  sx={{ ml: 6, pl: 1, wordBreak: "break-all" }}
                  onClick={(e) => handleSelect(name, field.name, field.type, field.length)}
                >
                  <ListItemText
                    primary={
                      <Box className={classes.ListItemText}>
                        <Typography variant="body2">{field.name}</Typography>
                        <Typography variant="body2" className={classes.fieldType}>
                          {field.type} {field.length ? `(${field.length})` : ""}
                        </Typography>
                      </Box>
                    }
                    secondary={
                      selectedMapping.entity === name && selectedMapping.field === field.name && saveDisabled ? (
                        <Typography color="error" fontSize="small">
                          {field.name} ({field.type}
                          {field.length ? ` - ${field.length}` : ""}) is not matching with {currentMapping.fieldName} (
                          {currentMapping.fieldType}
                          {currentMapping.fieldLength ? ` - ${currentMapping.fieldLength}` : ""})
                        </Typography>
                      ) : (
                        ""
                      )
                    }
                  />
                </ListItemButton>
              );
            }}
            initialItemCount={fields.length > initialItemCount ? initialItemCount : fields.length}
          />
        ) : (
          <ListItemText
            secondary={
              <Box className={classes.ListItemText}>
                <Typography variant="body2" sx={{ width: "100%", textAlign: "center" }}>
                  No attributes found
                </Typography>
              </Box>
            }
          />
        )}
      </List>
    </Collapse>
  );
}

export default React.memo(CollapsibleVirtulizedList);
